module.exports = __webpack_public_path__ + "static/media/badge.659ed2d7.png";